import fetch from '../utils/fetch'

export function caSearchAPI(data) {
    return fetch({
        url:  '/ca_member/search',
        method: "get",
        params: data,
    })
}

export function euSearchAPI(data) {
    return fetch({
        url:  '/eu_member/search',
        method: "get",
        params: data,
    })
}

export function countrySearchAPI(country, data) {
    return fetch({
        url:  `/${country}_member/search`,
        method: "get",
        params: data,
    })
}

export function detailAPI(country, data) {
    return fetch({
        url:  `/${country}_member/search/detail`,
        method: "get",
        params: data,
    })
}